import { AuthLayout } from "@/components/auth/AuthLayout";
import { LoginForm } from "@/components/auth/LoginForm";
import { usePageTitle } from "../hooks/usePageTitle";

export function LoginPage() {
  usePageTitle("Log in | TidyRota");

  return (
    <AuthLayout>
      <LoginForm />
    </AuthLayout>
  );
}
